<template>
  <section>
    <div class="row pb-3">
      <!-- Left Column: Input and Controls (Desktop) / Full Width (Mobile) -->
      <div class="col-lg-6 col-md-12">
        <!-- Barcode Input Form -->
        <div class="row">
          <div class="col-md-8 col-12">
            <div class="form-group" :class="{ 'has-error': barcodeError }">
              <label for="barcode_input">Bar Code</label>
              <input 
                type="text" 
                class="form-control" 
                id="barcode_input" 
                name="barcode" 
                aria-describedby="tpbarcode"
                placeholder="Bar Code" 
                autocomplete="on"
                v-model="barcodeInput"
                @keyup.enter="processBarcodeInput"
              >
              <label v-if="barcodeError" for="barcode_input" class="error">{{ barcodeErrorMessage }}</label>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="form-group">
              <label class="d-none d-md-block">&nbsp;</label>
              <div>
                <button 
                  @click="startBarcodeScanning" 
                  class="btn btn-primary btn-block mb-2"
                  type="button"
                  :disabled="cameraActive"
                >
                  <i class="fas fa-barcode"></i> 
                  Scan Barcode
                </button>
                <button 
                  @click="stopCamera" 
                  class="btn btn-danger btn-block"
                  type="button"
                  v-if="cameraActive"
                >
                  <i class="fas fa-stop"></i> 
                  Stop Camera
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Camera Permission Notice -->
        <div class="row" v-if="!cameraActive">
          <div class="col-12">
            <div class="alert alert-warning">
              <i class="fas fa-exclamation-triangle"></i>
              <strong>Camera Access Required:</strong>
              <p class="mb-2 mt-2">To use the barcode scanner, please allow camera access when prompted by your browser.</p>
              <small class="text-muted">
                <strong>Troubleshooting:</strong> If you don't see a permission prompt, check your browser's address bar for a camera icon and click "Allow", or manually enter barcodes in the text field above.
              </small>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Right Column: Camera Region (Desktop) / Full Width Below (Mobile) -->
      <div class="col-lg-6 col-md-12" v-if="cameraActive">
        <div class="alert alert-info mb-3">
          <i class="fas fa-info-circle"></i>
          <strong>Scanning Tips:</strong>
          <ul class="mb-0 mt-2">
            <li>Hold the barcode steady within the scanning area</li>
            <li>Ensure good lighting on the barcode</li>
            <li>Try different angles if not detecting</li>
            <li>Make sure the barcode is not damaged or blurry</li>
          </ul>
        </div>
        <div id="barcode-full-region" style="min-width: 300px; min-height: 300px; width: 100%; border: 2px solid #007bff; border-radius: 8px; position: relative;"></div>
        <div class="text-center mt-2">
          <small class="text-muted">
            <i class="fas fa-camera"></i> 
            Scanner is active - position barcode in the blue frame above
          </small>
        </div>
      </div>
    </div>

    <div
      v-for="(msg, index) in message"
      :key="index"
      style="white-space: pre-line"
    >
      <pre>decodedResult => {{ msg.decodedResult }}</pre>
    </div>
  </section>
</template>

<script>
import { Html5QrcodeScanner } from "html5-qrcode";
// To use Html5Qrcode (more info below)
import {Html5Qrcode, Html5QrcodeSupportedFormats} from "html5-qrcode"
import cameraManager from '../services/CameraManager.js'
export default {
  name: 'ScanBarcode',
  props: ["serialnumbers"],
  components: {
    //
  },
  data() {
    return {
      incremental: false,
      value: "",
      countries: [],
      packages: [],
      options: [],
      item_serial_numbers: [],
      item_serial_numbers_select: [],
      isLoading: false,
      item_type: 'type',
      search_term: "",
      scanned: false,
      message: [],
      incrementals: [],
      cameraActive: false,
      html5QrCode: null,
      scanningMode: 'qr', // 'qr' or 'barcode'
      barcodeInput: '',
      barcodeError: false,
      barcodeErrorMessage: '',
      items: [
        {
          description: "",
          quantity: "",
          remark: "",
          item_code: [],
          package_code: [],
          package_items: [],
        },
      ],
    };
  },
  mounted() {
    console.log("Component mounted.");
    console.log(this.items);
    this.countries = this.itemcode;
    this.items = this.orderitems;
    // Register with camera manager
    cameraManager.register(this);
    // this.refreshScanner();
    if (!this.isMobile()) {
      this.creatScan();
    }
    this.addItem();
  },
  beforeDestroy() {
    // Clean up camera and unregister from manager
    this.stopCamera();
    cameraManager.unregister(this);
  },
  methods: {
    validateForm(index){
      if(this.incrementals[index].starting > this.incrementals[index].ending || (incremental.starting != '' && incremental.ending == '')){
        $('#submit').prop("disabled",true);
      }else{
        $('#submit').prop("disabled",false);
      }
    },
    addItem() {
      this.incrementals.push({
        prefix: "",
        suffix: "",
        starting: "",
        ending: "",
      });
    },
    removeItem(index) {
      this.incrementals.splice(index, 1);
    },
    toggleCamera() {
      if (this.cameraActive) {
        this.stopCamera();
      } else {
        this.startCamera();
      }
    },
    startCamera() {
      this.cameraActive = true;
      this.$nextTick(() => {
        this.creatScan();
      });
    },
    stopCamera() {
      if (this.html5QrCode) {
        this.html5QrCode.stop().then(() => {
          this.cameraActive = false;
          this.html5QrCode = null;
          // Release camera from manager
          cameraManager.releaseCamera(this);
        }).catch((err) => {
          console.log(err);
          this.cameraActive = false;
          this.html5QrCode = null;
          // Release camera from manager even on error
          cameraManager.releaseCamera(this);
        });
      } else {
        this.cameraActive = false;
        // Release camera from manager
        cameraManager.releaseCamera(this);
      }
    },
    // Handle camera state changes from other components
    onCameraStateChanged(activeComponent, componentName) {
      if (activeComponent !== this && this.cameraActive) {
        console.log(`Camera taken by ${componentName}, stopping ScanBarcode camera`);
        this.stopCamera();
      }
    },
    startBarcodeScanning() {
      // Request camera access (this will automatically stop other cameras)
      cameraManager.requestCamera(this, 'ScanBarcode');
      
      this.cameraActive = true;
      this.scanningMode = 'barcode';
      
      // Wait for DOM to update before initializing scanner
      this.$nextTick(() => {
        // Check if the target element exists and has proper dimensions
        const targetElement = document.getElementById('barcode-full-region');
        if (!targetElement) {
          console.error('Scanner target element not found');
          this.cameraActive = false;
          alert('Scanner initialization failed. Please try again.');
          return;
        }
        
        // Ensure element has minimum dimensions
        if (targetElement.offsetWidth === 0 || targetElement.offsetHeight === 0) {
          console.warn('Scanner element has zero dimensions, setting minimum size');
          targetElement.style.minWidth = '400px';
          targetElement.style.minHeight = '300px';
        }
        
        this.creatScan();
      });
    },
    startQRCodeScanning() {
      this.scanningMode = 'qr';
      this.startCamera();
    },
    creatScan() {
      // This method will trigger user permissions
      Html5Qrcode.getCameras().then(devices => {
        /**
         * devices would be an array of objects of type:
         * { id: "id", label: "label" }
         */
        if (devices && devices.length) {
          // Double-check element exists before creating scanner
          const targetElement = document.getElementById('barcode-full-region');
          if (!targetElement) {
            console.error('Target element disappeared during initialization');
            this.cameraActive = false;
            return;
          }
          
          var cameraId = devices[0].id;
          this.html5QrCode = new Html5Qrcode(/* element id */ "barcode-full-region", /* verbose= */ false);
          
          // Configure scanning based on mode
          // Calculate qrbox size based on container dimensions - increased for better detection
          const containerWidth = targetElement.offsetWidth || 400;
          const containerHeight = targetElement.offsetHeight || 300;
          const qrboxSize = Math.min(containerWidth * 0.9, containerHeight * 0.9, 400); // Increased from 0.8 to 0.9 and max from 250 to 400
          
          const config = {
            fps: 10, // Increased FPS for better detection responsiveness
            qrbox: Math.max(qrboxSize, 200), // Increased minimum from 150 to 200 for better detection
            aspectRatio: 1.5, // Adjusted aspect ratio for better barcode detection
            disableFlip: false, // Allow horizontal flip for better scanning
            rememberLastUsedCamera: true, // Remember camera selection
            experimentalFeatures: {
              useBarCodeDetectorIfSupported: true
            }
          };
          
          // Add comprehensive barcode format support
          if (this.scanningMode === 'barcode') {
            config.supportedScanTypes = [
              'SCAN_TYPE_CAMERA'
            ];
            config.formatsToSupport = [
              Html5QrcodeSupportedFormats.QR_CODE,
              Html5QrcodeSupportedFormats.CODE_128,
              Html5QrcodeSupportedFormats.CODE_39,
              Html5QrcodeSupportedFormats.CODE_93,
              Html5QrcodeSupportedFormats.CODABAR,
              Html5QrcodeSupportedFormats.EAN_13,
              Html5QrcodeSupportedFormats.EAN_8,
              Html5QrcodeSupportedFormats.UPC_A,
              Html5QrcodeSupportedFormats.UPC_E,
              Html5QrcodeSupportedFormats.ITF,
              Html5QrcodeSupportedFormats.DATA_MATRIX,
              Html5QrcodeSupportedFormats.PDF_417
            ];
          }
          
          // Camera constraints - html5-qrcode expects facingMode as string
          const cameraConstraints = {
            facingMode: "environment" // Use environment camera for barcode scanning
          };
          
          this.html5QrCode.start(
            cameraConstraints,
            config,
            (decodedText, decodedResult) => {
              console.log('✅ Barcode/QR Code detected:', decodedText, 'Format:', decodedResult.result?.format);
              // Play success sound if available
              try {
                const audio = new Audio('/audio/Barcode-scanner-beep-sound.mp3');
                audio.play().catch(e => console.log('Audio play failed:', e));
              } catch (e) {
                console.log('Audio not available');
              }
              // Add to input field and tag list
              this.barcodeInput = decodedText;
              this.addTag(decodedText);
              // Optionally stop scanning after successful read
              // this.stopCamera();
            },
            (errorMessage) => {
              // Log scanning attempts for debugging
              if (errorMessage.includes('NotFoundException')) {
                // This is normal - scanner is actively looking
                console.debug('🔍 Scanning for barcode...');
              } else if (!errorMessage.includes('No MultiFormat Readers') &&
                        !errorMessage.includes('decodeRow')) {
                console.warn('⚠️ Scanning error:', errorMessage);
              }
            }
          ).catch((err) => {
            console.error('Camera initialization failed:', err);
            this.cameraActive = false;
            
            // Provide specific error messages for camera start failures
            let errorMessage = 'Failed to start camera.';
            
            if (err.name === 'NotAllowedError' || err.message.includes('Permission denied')) {
              errorMessage = 'Camera permission was denied. Please:\n\n' +
                            '1. Refresh the page\n' +
                            '2. Click "Allow" when prompted for camera access\n' +
                            '3. Check browser settings if the prompt doesn\'t appear';
            } else if (err.name === 'NotReadableError') {
              errorMessage = 'Camera is busy or hardware error. Please:\n\n' +
                            '1. Close other applications using the camera\n' +
                            '2. Restart your browser\n' +
                            '3. Check camera hardware connection';
            } else if (err.name === 'OverconstrainedError') {
              errorMessage = 'Camera constraints not supported. Please:\n\n' +
                            '1. Try a different camera if available\n' +
                            '2. Update your browser\n' +
                            '3. Check camera compatibility';
            } else {
              errorMessage = 'Camera initialization failed. Please:\n\n' +
                            '1. Check camera permissions\n' +
                            '2. Ensure camera is not in use by other apps\n' +
                            '3. Try refreshing the page';
            }
            
            alert(errorMessage);
          });
          // html5QrCode.start(
            
          //   cameraId, 
          //   {
          //     fps: 10,    // Optional, frame per seconds for qr code scanning
          //     qrbox: 250 ,
          //     aspectRatio: 2,
          //     // qrbox: { width: 250, height: 250 }  // Optional, if you want bounded box UI
          //   },
          //   (decodedText, decodedResult) => {
          //     // do something when code is read
          //   },
          //   (errorMessage) => {
          //     // parse error, ignore it.
          //   })
          // .catch((err) => {
          //   // Start failed, handle it.
          // });
        }
      }).catch(err => {
        console.error('Camera device access error:', err);
        this.cameraActive = false;
        
        // Provide more specific error messages based on the error type
        let errorMessage = 'Unable to access camera devices.';
        
        if (err.name === 'NotAllowedError' || err.message.includes('Permission denied')) {
          errorMessage = 'Camera permission denied. Please:\n\n' +
                        '1. Click the camera icon in your browser\'s address bar\n' +
                        '2. Select "Allow" for camera access\n' +
                        '3. Refresh the page and try again\n\n' +
                        'Or check your browser settings to enable camera permissions for this site.';
        } else if (err.name === 'NotFoundError' || err.message.includes('No camera found')) {
          errorMessage = 'No camera devices found. Please:\n\n' +
                        '1. Ensure your device has a camera\n' +
                        '2. Check that no other applications are using the camera\n' +
                        '3. Try refreshing the page';
        } else if (err.name === 'NotSupportedError') {
          errorMessage = 'Camera access is not supported in this browser. Please:\n\n' +
                        '1. Use a modern browser (Chrome, Firefox, Safari, Edge)\n' +
                        '2. Ensure you\'re accessing the site via HTTPS\n' +
                        '3. Try using a different browser';
        } else if (err.name === 'NotReadableError') {
          errorMessage = 'Camera is already in use by another application. Please:\n\n' +
                        '1. Close other applications using the camera\n' +
                        '2. Restart your browser\n' +
                        '3. Try again';
        }
        
        alert(errorMessage);
      });
      // const config = { fps: 10, qrbox: 250 ,aspectRatio: 2};
      // const html5QrcodeScanner = new Html5QrcodeScanner(
      //   "barcode-full-region",
      //   config
      // );
      // html5QrcodeScanner.render(this.onScanSuccess);
      // html5QrcodeScanner.applyVideoConstraints({ focusMode: "continuous", advanced: [ {zoom: isAndroid ? 1.5 : 2.0 } ]})
    },
    onScanSuccess(decodedText, decodedResult) {
      this.scanSuccessFile(decodedText)
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    refreshScanner(){
      var html5QrcodeScanner = new Html5QrcodeScanner(
            "qr-reader", { fps: 10, qrbox: { width: 400, height: 250 },experimentalFeatures: {useBarCodeDetectorIfSupported: true}, });
        html5QrcodeScanner.render(onScanSuccess);
        var that = this
        html5QrcodeScanner.applyVideoConstraints({ focusMode: "continuous", advanced: [ {zoom: isAndroid ? 1.5 : 2.0 } ]})
        function onScanSuccess(decodedText, decodedResult) {
          console.log(`Code scanned = ${decodedText}`, decodedResult);
          that.scanSuccessFile(decodedText)
        }
    },
    scanSuccessFile(decodedText){
      this.scanned = true
      this.addTag(decodedText)
    },
    removeVal(tag){
      console.log(tag)
      const index = this.item_serial_numbers.indexOf(tag.serial_number);
      if (index > -1) {
        this.item_serial_numbers.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    updateModel(newTag){
      this.item_serial_numbers.push(newTag.serial_number)
      this.serialnumbers.push(newTag)
    },
    processBarcodeInput() {
      if (this.barcodeInput.trim() !== '') {
        this.addTag(this.barcodeInput.trim());
        this.barcodeInput = '';
        this.barcodeError = false;
        this.barcodeErrorMessage = '';
      } else {
        this.barcodeError = true;
        this.barcodeErrorMessage = 'Please enter a valid barcode';
      }
    },
    addTag (newTag) {
      const tag = {
        serial_number: newTag,
        item_code: '',
      }
      var exist = false;
      for (let index = 0; index < this.item_serial_numbers_select.length; index++) {
        if(this.item_serial_numbers_select[index].serial_number == newTag){
          exist = true
        }
      }
      if(!exist){
        if(this.scanned){
          var audio = new Audio('/audio/Barcode-scanner-beep-sound.mp3'); // path to file
          audio.play();
          this.scanned = false
        }
        this.serialnumbers.push(tag)
        this.item_serial_numbers_select.push(tag)
        this.item_serial_numbers.push(newTag)
      }else{
        // alert('Serial Number already chosen')
      }
      this.refreshScanner()
    },
    setSerialNoVal(){
      this.item_serial_numbers = ''
      for (let index = 0; index < this.item_serial_numbers_select.length; index++) {
        this.item_serial_numbers += this.item_serial_numbers_select[index].serial_number+', '
      }
    },
    limitText(count) {
      return `and ${count} other countries`;
    },
    asyncFind(query) {
      this.search_term = query;
      if (query && query != "") {
        this.isLoading = true;
        axios
          .get("/ajax/search-ac?parameter=" + query)
          .then((response) => {
            if (this.search_term == response.data.search_term) {
              this.countries = response.data.data;
              this.isLoading = false;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    asyncPackageFind(query) {
      this.search_term = query;
      if (query && query != "") {
        this.isLoading = true;
        axios
          .get("/ajax/search-ac-package?parameter=" + query)
          .then((response) => {
            if (this.search_term == response.data.search_term) {
              this.packages = response.data.data;
              this.isLoading = false;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    clearAll() {
      this.selectedCountries = [];
    },
    packageQtyChange(index1) {
      if (this.items[index1].package_items) {
        for (
          let index = 0;
          index < this.items[index1].package_items.length;
          index++
        ) {
          this.items[index1].package_items[index].item_quantity = this.items[
            index1
          ].package_items[index].item_quantity
            ? this.items[index1].package_items[index].item_quantity *
              this.items[index1].quantity
            : "";
        }
      }
    },
    setItemVal() {
      this.countries = [];
    },
    setPackageVal(item) {
      this.packages = [];
      if (item && item.package_code && item.package_code.package_dockey != "") {
        this.isLoading = true;
        var search = item.package_code.package_dockey;
        axios
          .get("/ajax/search-ac-package-item?parameter=" + search)
          .then((response) => {
            for (let index = 0; index < item.package_items.length; index++) {
              item[index1].package_items[index].item_quantity = item
                .package_items[index].item_quantity
                ? item.package_items[index].item_quantity * item.quantity
                : "";
            }
            item.package_items = response.data.data;
            this.isLoading = false;
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    retrieveItemCode() {
      axios
        .get("/ajax/search-ac?parameter=" + this.items[index].item_code)
        .then(({ data }) => {
          var a = [];
          for (var i = 0; i < data.length; i++) {
            var temp = { value: data[i]["id"], name: data[i]["name"] };
            a.push(temp);
          }
          this.customers = a;
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>